import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-07423426"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "info-box"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["image-infomation-container", {
      disabled: !_ctx.desc
    }]),
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.onClickItem && _ctx.onClickItem.apply(_ctx, args);
    })
  }, [_createElementVNode("div", {
    class: "hover-image hover-image-absolute",
    style: _normalizeStyle("background-image: url(".concat(_ctx.image, ")"))
  }, null, 4), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.desc), 1)])], 2);
}